import React from 'react';
import { Link } from 'react-router-dom';

function UserRoles() {
  return (
    <div className="docs-content">
      <h1>User Roles</h1>
      <p className="docs-lead">
        SignTada uses three roles to control what users can see and do: User, Admin, and Super Admin. Permissions are enforced in both the dashboard and the API.
      </p>

      <h2>USER</h2>
      <p>
        Standard users can use the dashboard to view stats, send document requests, create and use templates, and see the list of documents and their signing status. They can download signed PDFs and audit trails. They <strong>cannot</strong> manage webhooks, add or remove users, change company settings, or configure branding. Credits are visible but not manageable.
      </p>

      <h2>ADMIN</h2>
      <p>
        Admins have all User capabilities, plus the ability to manage <strong>webhooks</strong> (configure URLs, view logs, resend failed deliveries), <strong>invite and manage users</strong> within their company, and configure <strong>branding</strong> (logo, product name, primary and accent colors, theme) for their organization in Settings. They see their company’s credit balance and usage but cannot create companies or add credits; that is reserved for Super Admins.
      </p>

      <h2>SUPER_ADMIN</h2>
      <p>
        Super Admins have full access. They can create companies, add credits to any company, and use the company switcher in the top bar to view “All Companies” or a specific company. They manage all users across companies, configure branding per company, and perform any action available in the dashboard and via the API. The first user to register in the system is automatically assigned the Super Admin role.
      </p>

      <h2>Credits</h2>
      <p>
        Signing requests consume credits. Admins see their company’s credit balance on the dashboard; Super Admins can add credits to companies from Settings. When credits run low, contact your administrator or Super Admin to top up.
      </p>

      <h2>API behavior</h2>
      <p>
        The API respects the same roles. Endpoints for listing or managing users, webhooks, or branding require Admin or Super Admin privileges where applicable. See the <Link to="/api-reference">API Reference</Link> for per-endpoint authentication and scope requirements.
      </p>

      <p>
        <Link to="/quick-start">← Quick Start</Link> · <Link to="/dashboard">Dashboard Guide →</Link>
      </p>
    </div>
  );
}

export default UserRoles;
